import axios from '../utils/axios';

export default function getPaymentSyncRecords (adminId, params) {
    return axios.get(`/admin/${adminId}/get-payment-sync-records`, { params });
}